import React, { type ReactNode } from 'react';
import uniqid from 'uniqid';

import Icons from 'assets/icons';

interface SortingParam {
  id: string;
  desc: boolean;
}

export const getSortIcon = (
  sortingParams: SortingParam[],
  columnId: string,
  enableSorting: boolean | undefined
): ReactNode => {
  const defaultSortIcon = (
    <Icons.DefaultSort
      key={uniqid()}
      customClass="mt-[4px]"
      aria-label="header-icon"
      height="100%"
      width="13"
    />
  );

  if (enableSorting) {
    if (!!sortingParams.length) {
      const sortedItem = sortingParams.find((sort) => sort.id === columnId);

      if (!sortedItem) return defaultSortIcon;

      return sortedItem?.desc ? (
        <Icons.Sort
          key={uniqid()}
          aria-label="sort-up-icon"
          height="100%"
          width="14"
        />
      ) : (
        <Icons.Sort
          key={uniqid()}
          aria-label="sort-down-icon"
          height="100%"
          width="14"
          customClass="rotate-180 mt-0.5"
        />
      );
    }

    return defaultSortIcon;
  }

  return undefined;
};
